import './App.css';
import Cart from './pages/Cart';
import Home from './pages/Home';
import Login from './pages/Login';
import ProductList from './pages/ProductList';
import Register from './pages/Register';
import SingleProduct from './pages/SingleProduct';
import { BrowserRouter, Routes, Route,Navigate } from "react-router-dom";
import NoPage from './components/NoPage';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
         
         <Routes>
          
           <Route exact path="/" element={<Home />} />
           <Route path="/shop" element={<Home />} />
           <Route path="/products/:category" element={<ProductList />} />
           <Route path="/product/:id" element={<SingleProduct />} />
           <Route path="/cart" element={<Cart />} />
           <Route path="/register" element={<Register />} />
           <Route path="/login" element={<Login />} />
           <Route path="*" element={<NoPage />} />
         </Routes>
       </BrowserRouter>
    </div>
  );
}

export default App;
